import { render, staticRenderFns } from "./mingxiList.vue?vue&type=template&id=41749851&"
import script from "./mingxiList.vue?vue&type=script&lang=js&"
export * from "./mingxiList.vue?vue&type=script&lang=js&"
import style0 from "./mingxiList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports